/**
 * Custom hooks for API calls using SWR
 */
import useSWR from "swr";
import { fetcher } from "../lib/api";

/**
 * Hook for admin dashboard stats
 */
export function useAdminStats() {
  const { data, error, isLoading, mutate } = useSWR(
    "/api/admin/dashboard/stats",
    fetcher
  );
  
  return {
    stats: data,
    isLoading,
    isError: error,
    mutate,
  };
}

/**
 * Hook for clients list (admin)
 */
export function useClients() {
  const { data, error, isLoading, mutate } = useSWR(
    "/api/admin/clients",
    fetcher
  );
  
  return {
    clients: data || [],
    isLoading,
    isError: error,
    mutate,
  };
}

/**
 * Hook for client dashboard
 */
export function useClientDashboard() {
  const { data, error, isLoading, mutate } = useSWR(
    "/api/client/dashboard",
    fetcher
  );
  
  return {
    dashboard: data,
    isLoading,
    isError: error,
    mutate,
  };
}

/**
 * Hook for client profile
 */
export function useClientProfile() {
  const { data, error, isLoading, mutate } = useSWR(
    "/api/client/profile",
    fetcher
  );
  
  return {
    profile: data,
    isLoading,
    isError: error,
    mutate,
  };
}

/**
 * Hook for client features
 */
export function useClientFeatures() {
  const { data, error, isLoading, mutate } = useSWR(
    "/api/client/features",
    fetcher
  );
  
  return {
    features: data,
    isLoading,
    isError: error,
    mutate,
  };
}
